import { Link, Typography } from '@mui/material';
import type { TransformedSubmission } from 'api/submission';
import { FeedbackWrapper } from 'components/FeedbackWrapper';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import type { FC, ReactNode } from 'react';

const BoldText = ({ children }: { children: ReactNode }) => (
  <Typography
    component="span"
    variant="inherit"
    sx={{
      display: 'inline-block',
      color: (theme) => theme.palette.customColors.textNeutralPrimary,
    }}
  >
    {children}
  </Typography>
);

const PhoneLink = ({ phone }: { phone: string }) => (
  <Link
    sx={{ color: (theme) => theme.palette.customColors.copper, textDecoration: 'none' }}
    href={`tel:${phone}`}
    target="_blank"
  >
    {phone}
  </Link>
);

const TIVLY_INFO = {
  title: "We don't have what you need, but our friends at Tivly can help!",
  subtitle: () => (
    <>
      <BoldText>Call now</BoldText> at <PhoneLink phone="855-683-0688" /> to connect with one of
      Tivly&apos;s representatives, or <BoldText>click below</BoldText> to start an online quote.
    </>
  ),
  button: {
    title: 'Get Tivly Quote',
    href: 'https://tivly.com/three-insurance?sr=clementine2',
  },
};

const BOLD_PENGUIN_INFO = {
  title: "We don't have what you need, but our friends at Bold Penguin can help!",
  subtitle: () => (
    <>
      <BoldText>Call now</BoldText> at <PhoneLink phone="308-730-4321" /> to connect with one of
      Bold Penguin&apos;s representatives, or <BoldText>click below</BoldText> to start an online
      quote.
    </>
  ),
  button: {
    title: 'Get Bold Penguin Quote',
    href: 'https://www.commercialinsurancecenter.com/three',
  },
};

type TivlyOrBoldPenguinCTAProps = {
  submission: TransformedSubmission;
};

const TivlyOrBoldPenguinCTA: FC<TivlyOrBoldPenguinCTAProps> = ({ submission }) => {
  const isTivly = submission?.third_party_referral_partner === 'tivly';

  const data = isTivly ? TIVLY_INFO : BOLD_PENGUIN_INFO;

  return (
    <FeedbackWrapper
      feedback="none"
      title={data.title}
      renderAdditionalInfo={false}
      renderHomeButton={false}
    >
      <Typography
        variant="h2"
        lineHeight="140% !important"
        sx={{ color: (theme) => theme.palette.customColors.textNeutralTertiary }}
      >
        {data.subtitle()}
      </Typography>
      <PrimaryButton
        text={data.button.title}
        href={data.button.href}
        sx={{ mt: 4 }}
        target="_blank"
      />
    </FeedbackWrapper>
  );
};

export default TivlyOrBoldPenguinCTA;
